<template>
  <div>
    <b-modal
        scrollable
      id="offline-Order"
      ref="modal"
      header-class="headerModal"
      centered
      title="title"
      hide-footer
    >
      <span style="color: #262E6C; font-weight: bold;">
        {{ $t('OfflineOrderModalText') }}
      </span>
      <div class="buttonsEverywhere">
        <b-button
          type="reset"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: [],
  data() {
    return {
    }
  },
  methods: {
    ...mapActions([]),
    onCancel() {
      this.$refs.modal.hide();
      this.$emit('cancelModals');
    },
  },
}
</script>

  <style lang="scss" scoped>


  </style>
